import { FontSize } from "~/enums/fontSize";
import { SearchMatchType } from "~/enums/searchMatchType";
import { LookupFieldType } from "../../../../common/enums/lookupFieldType";
import { DatetimeMode } from "../../../../common/models/datetimeMode";
import { DatetimeType } from "../../../../common/models/datetimeType";
import { TimeFormat } from "../../../../common/models/timeFormat";
import { OptionRangeType } from "~/enums/optionRangeType";
import { CurrencyType } from "../currencyType";
import { DefaultOptionType } from "../defaultOptionType";
import { Capability } from "./formElementCapability";
import { FormElementType } from "~/enums/formElementType";
import { FrameShape } from "~/models/formElements/frameShape";
import { VerticalAlignment } from "~/enums/verticalAlignment";
import FormElementControlGroups from "~/models/formElements/formElementControlGroups"

type lockables = 'is_repeatable' | 'help_text' | 'reference_name' | 'format' | 'label_title' | 'layout_config' | 'placeholder_text' | 'is_required' | 'datetime' | 'is_multiple' | 'individual_max_file_size_mb' | 'total_max_file_size_mb' | 'default_option' | 'default_option_id' | 'default_value' | 'is_masked' | 'is_readonly' | 'default_show' | 'character_count' | 'request_phone' | 'column_count' | 'check_by_default';

export default class FormElementCapabilityManager {
  static debug: boolean = false;

  static ALL_CONTROLS = [...FormElementControlGroups.ALL_CONTROLS];

  static SELECTABLE_CONTROLS = [...FormElementControlGroups.SELECTABLE_CONTROLS];

  static SHOW_HIDDEABLE_CONTROLS = [...FormElementControlGroups.SHOW_HIDDEABLE_CONTROLS]

  static LABELABLE_CONTROLS = [...FormElementControlGroups.LABELABLE_CONTROLS];

  static WYSIWYG_LABELABLE_CONTROLS = [...FormElementControlGroups.WYSIWYG_LABELABLE_CONTROLS];

  static PLACEHOLDERABLE_CONTROLS = [...FormElementControlGroups.PLACEHOLDERABLE_CONTROLS];

  static REQUIREABLE_CONTROLS = [...FormElementControlGroups.REQUIREABLE_CONTROLS];

  static FORMATABLE_CONTROLS = [...FormElementControlGroups.FORMATABLE_CONTROLS];

  static LENGTHABLE_CONTROLS = [...FormElementControlGroups.LENGTHABLE_CONTROLS];

  static REFERENCEABLE_CONTROLS = [...FormElementControlGroups.REFERENCEABLE_CONTROLS];

  static SUBREFERENCEABLE_CONTROLS = [...FormElementControlGroups.SUBREFERENCEABLE_CONTROLS];

  static HELP_TEXTABLE_CONTROLS = [...FormElementControlGroups.HELP_TEXTABLE_CONTROLS];

  static REPEATABLE_CONTROLS = [...FormElementControlGroups.REPEATABLE_CONTROLS];

  static DEFAULTABLE_CONTROLS = [...FormElementControlGroups.DEFAULTABLE_CONTROLS];

  static MASKABLE_CONTROLS = [...FormElementControlGroups.MASKABLE_CONTROLS];

  static LAYOUTABLE_CONTROLS = [...FormElementControlGroups.LAYOUTABLE_CONTROLS];

  static LAYOUT_CONTAINER_CONTROLS = [...FormElementControlGroups.LAYOUT_CONTAINER_CONTROLS];

  static NUMERIC_MIN_MAXABLE_CONTROLS = [...FormElementControlGroups.NUMERIC_MIN_MAXABLE_CONTROLS];

  static DATE_MIN_MAXABLE_CONTROLS = [...FormElementControlGroups.DATE_MIN_MAXABLE_CONTROLS];

  static COLUMNABLE_CONTROLS = [...FormElementControlGroups.COLUMNABLE_CONTROLS];

  static SIZEABLE_FONT_CONTROLS = [...FormElementControlGroups.SIZEABLE_FONT_CONTROLS];

  static OPTION_COLLECTION_CONTROLS = [...FormElementControlGroups.OPTION_COLLECTION_CONTROLS];

  static OPTION_CONTROLS = [...FormElementControlGroups.OPTION_CONTROLS];

  static DEFAULT_OPTION_CONTROLS = [...FormElementControlGroups.DEFAULT_OPTION_CONTROLS];

  static DEFAULT_CLICK_CONTROLS = [...FormElementControlGroups.DEFAULT_CLICK_CONTROLS];

  static OPTION_RANGE_REQUIRABLE_CONTROLS = [...FormElementControlGroups.OPTION_RANGE_REQUIRABLE_CONTROLS];

  static READONLYABLE_CONTROLS = [...FormElementControlGroups.READONLYABLE_CONTROLS];

  static INDEXABLE_CONTROLS: FormElementType[] = [...FormElementControlGroups.INDEXABLE_CONTROLS];

  static VERTICAL_ALIGN = [...FormElementControlGroups.VERTICAL_ALIGN];

  static RESIZABLE_CONTROLS = [...FormElementControlGroups.RESIZABLE_CONTROLS];

  static DATA_REFERENCABLE_CONTROLS: FormElementType[] = [...FormElementControlGroups.DATA_REFERENCABLE_CONTROLS];

  static PROFILE_CONFIG_CONTROLS: FormElementType[] = [...FormElementControlGroups.PROFILE_CONFIG_CONTROLS]

  static VALIDATION_RULE_CONTROLS: FormElementType[] = [...FormElementControlGroups.VALIDATION_RULE_CONTROLS]

  static DISPLAY_LABLEABLE_CONTROLS: FormElementType[]=[
    FormElementType.checkbox,
  ]

  static VISUAL_CONTROLS: FormElementType[] = [...FormElementControlGroups.VISUAL_CONTROLS]

  static TEMPLATE_CONTROLS: FormElementType[] = [...FormElementControlGroups.TEMPLATE_CONTROLS]

  static UPLOAD_CONTROLS: FormElementType[] = [...FormElementControlGroups.UPLOAD_CONTROLS]

  static SIGNATURE_CONTROLS: FormElementType[] = [...FormElementControlGroups.SIGNATURE_CONTROLS]

  static LOOKUP_CONTROLS: FormElementType[] = [...FormElementControlGroups.LOOKUP_CONTROLS]

  static WYSIWYG_FORMATTABLE_CONTROLS: FormElementType[] = [...FormElementControlGroups.WYSIWYG_FORMATTABLE_CONTROLS]

  /**
   * Any element that may contain other elements
   */
  static CONTAINER_CONTROLS: FormElementType[] = [...FormElementControlGroups.CONTAINER_CONTROLS]

  static VALIDATION_MODE_CONTROLS: FormElementType[] = [...FormElementControlGroups.VALIDATION_MODE_CONTROLS]

  static LOCKABLE_PROPERTIES: lockables[];

  static formElementCan(type: FormElementType, duty: Capability) {
    let can: boolean = false;
    switch (duty) {
      case Capability.selectable:
        can = FormElementCapabilityManager.SELECTABLE_CONTROLS.includes(type);
        break;
      case Capability.labelable:
        can = FormElementCapabilityManager.LABELABLE_CONTROLS.includes(type);
        break;
      case Capability.wysiwygLabelable:
        can = FormElementCapabilityManager.WYSIWYG_LABELABLE_CONTROLS.includes(type);
        break;
      case Capability.placeholderable:
        can = FormElementCapabilityManager.PLACEHOLDERABLE_CONTROLS.includes(type);
        break;
      case Capability.requireable:
        can = FormElementCapabilityManager.REQUIREABLE_CONTROLS.includes(type);
        break;
      case Capability.formatable:
        can = FormElementCapabilityManager.FORMATABLE_CONTROLS.includes(type);
        break;
      case Capability.lengthable:
        can = FormElementCapabilityManager.LENGTHABLE_CONTROLS.includes(type);
        break;
      case Capability.referenceable:
        can = FormElementCapabilityManager.REFERENCEABLE_CONTROLS.includes(type);;
        break;
      case Capability.subreferenceable:
        can = FormElementCapabilityManager.SUBREFERENCEABLE_CONTROLS.includes(type);
        break;
      case Capability.helpTextable:
        can = FormElementCapabilityManager.HELP_TEXTABLE_CONTROLS.includes(type);
        break;
      case Capability.repeatable:
        can = FormElementCapabilityManager.REPEATABLE_CONTROLS.includes(type);
        break;
      case Capability.layoutable:
        can = FormElementCapabilityManager.LAYOUTABLE_CONTROLS.includes(type);
        break;
      case Capability.numericMinMaxable:
        can = FormElementCapabilityManager.NUMERIC_MIN_MAXABLE_CONTROLS.includes(type);
        break;
      case Capability.dateMinMaxable:
        can = FormElementCapabilityManager.DATE_MIN_MAXABLE_CONTROLS.includes(type);
        break;
      case Capability.sizeableFont:
        can = FormElementCapabilityManager.SIZEABLE_FONT_CONTROLS.includes(type);
        break;
      case Capability.fileMode:
        can = type === FormElementType.uploadFiles;
        break;
      case Capability.columnable:
        can = FormElementCapabilityManager.COLUMNABLE_CONTROLS.includes(type);
        break;
      case Capability.pageBreak:
        can = type === FormElementType.pageBreak;
        break;
      case Capability.defaultOption:
        can = FormElementCapabilityManager.DEFAULT_OPTION_CONTROLS.includes(type);
        break;
      case Capability.layoutContainer:
        can = FormElementCapabilityManager.LAYOUT_CONTAINER_CONTROLS.includes(type);
        break;
      case Capability.defaultable:
        can = FormElementCapabilityManager.DEFAULTABLE_CONTROLS.includes(type);
        break;
      case Capability.maskable:
        can = FormElementCapabilityManager.MASKABLE_CONTROLS.includes(type);
        break;
      case Capability.checkByDefault:
        can = FormElementCapabilityManager.DEFAULT_CLICK_CONTROLS.includes(type);
        break;
      case Capability.readonlyable:
        can = FormElementCapabilityManager.READONLYABLE_CONTROLS.includes(type);
        break;
      case Capability.optionRangeRequirable:
        can = FormElementCapabilityManager.OPTION_RANGE_REQUIRABLE_CONTROLS.includes(type);
        break;
      case Capability.showHideable:
        can = FormElementCapabilityManager.SHOW_HIDDEABLE_CONTROLS.includes(type);
        break;
      case Capability.sortable:
        can = true;
        break;
      case Capability.destroyable:
        can = true;
        break;
      case Capability.thirdPartyCompleter:
        can = type === FormElementType.thirdParty;
        break;
      case Capability.indexable:
        can = FormElementCapabilityManager.INDEXABLE_CONTROLS.includes(type);
        break;
      case Capability.verticalAlign:
        can = FormElementCapabilityManager.VERTICAL_ALIGN.includes(type);
        break;
      case Capability.resizable:
        can = FormElementCapabilityManager.RESIZABLE_CONTROLS.includes(type);
        break;
      case Capability.dataReferencable:
        can = FormElementCapabilityManager.DATA_REFERENCABLE_CONTROLS.includes(type);
        break;
      case Capability.profileConfig:
        can = FormElementCapabilityManager.PROFILE_CONFIG_CONTROLS.includes(type);
        break;
      case Capability.validationRule:
        can = FormElementCapabilityManager.VALIDATION_RULE_CONTROLS.includes(type)
        break;
      case Capability.displayLableable:
        can = FormElementCapabilityManager.DISPLAY_LABLEABLE_CONTROLS.includes(type)
        break;
      case Capability.wysiwygFormattable:
        can = FormElementCapabilityManager.WYSIWYG_FORMATTABLE_CONTROLS.includes(type)
        break;
      case Capability.container:
        can = FormElementCapabilityManager.CONTAINER_CONTROLS.includes(type)
        break;
      case Capability.signature:
        can = FormElementCapabilityManager.SIGNATURE_CONTROLS.includes(type)
        break
      case Capability.validationMode:
        can = FormElementCapabilityManager.VALIDATION_MODE_CONTROLS.includes(type)
        break
      default:
        can = false;
        break;
    }
    FormElementCapabilityManager.log(`Type ${FormElementType[type]} ${can ? 'can' : 'can\'t'} ${Capability[duty]}`);
    return can;
  }

  static addDefaultProperties(el) {
    if (el.can(Capability.labelable) || el.can(Capability.wysiwygLabelable)) {
      el.defineProperty('label_title', null);
      el.defineProperty('label_title_locked', el.inFormTemplate);
    }
    if (el.can(Capability.displayLableable)){
      el.defineProperty("has_display_label", false)
      el.defineProperty("display_label", "")
    }
    if (el.can(Capability.layoutable)) {
      el.defineProperty('layout_config', [1, 1]);
      el.defineProperty('layout_config_locked', el.inFormTemplate);
    }
    if (el.can(Capability.placeholderable)) {
      let initialValue = '';
      if (el.element_type === FormElementType.dateTimePicker) {
        initialValue = 'MM/DD/YYYY';
      }
      el.defineProperty('placeholder_text', initialValue);
      el.defineProperty('placeholder_text_locked', el.inFormTemplate);
    }
    if (el.can(Capability.requireable)) {
      let initialValue = '';
      if (el.element_type === FormElementType.textArea || el.element_type ===  FormElementType.textField ){
          initialValue = "Please enter a value"
      }else if (el.element_type === FormElementType.dropdown || el.element_type === FormElementType.radioButtonGroup){
        initialValue = "Please select an option"
      }else if(el.element_type === FormElementType.checkboxGroup){
        initialValue = "Please select at least 1 choice"
      }else if(el.element_type === FormElementType.dateTimePicker){
        initialValue = "Please enter a valid date"
      }else if(el.element_type === FormElementType.uploadFiles){
        initialValue = "Please upload a file"
      } else if (el.element_type === FormElementType.imageUpload){
        initialValue = "Please upload an image"
      }else if(el.element_type === FormElementType.signature){
        initialValue = "Please include e-signature and agree to terms"
      }
      el.defineProperty('is_required', false);
      el.defineProperty('required_message', initialValue);
      el.defineProperty('is_required_locked', el.inFormTemplate);
    }
    if (el.can(Capability.formatable)) {
      el.defineProperty('format_type', -1);
      el.defineProperty('format_message', '');
      el.defineProperty('format_pattern', '');
      el.defineProperty('decimal_places', null);
      el.defineProperty('currency_type', CurrencyType.USD);
      el.defineProperty('format_locked', el.inFormTemplate);
      el.defineProperty('format_numeric_with_commas', false);
    }
    if (el.canBe(Capability.referenceable)) {
      el.defineProperty('reference_name', null);
      el.defineProperty('reference_name_locked', el.inFormTemplate);
    }
    if (el.can(Capability.helpTextable)) {
      el.defineProperty('help_text', null);
      el.defineProperty('help_text_locked', el.inFormTemplate);
    }
    if (el.can(Capability.repeatable)) {
      el.defineProperty('is_repeatable', false);
      el.defineProperty('add_repeatable_message', '');
      el.defineProperty('min_repeatable_instances', null);
      el.defineProperty('max_repeatable_instances', null);
      el.defineProperty('is_repeatable_locked', el.inFormTemplate);
    }
    if (el.can(Capability.numericMinMaxable)) {
      el.defineProperty('min_value', null);
      el.defineProperty('max_value', null);
    }
    if (el.can(Capability.dateMinMaxable)) {
      el.defineProperty('datetime_mode', DatetimeMode.Date);
      el.defineProperty('min_datetime', null);
      el.defineProperty('min_datetime_type', DatetimeType.None);
      el.defineProperty('max_datetime', null);
      el.defineProperty('max_datetime_type', DatetimeType.None);
      el.defineProperty('time_format', TimeFormat.TwelveHour);
      el.defineProperty('default_datetime_type', DatetimeType.None);
      el.defineProperty('default_datetime', null);
      el.defineProperty('default_datetime_formula', null);

      el.defineProperty('datetime_locked', el.inFormTemplate);
    }
    if (el.can(Capability.sizeableFont)) {
      el.defineProperty('font_size', FontSize.Large);
    }
    if (el.can(Capability.fileMode)) {
      el.defineProperty('is_multiple', true);
      el.defineProperty('individual_max_file_size_mb', 32);
      el.defineProperty('total_max_file_size_mb', 256);
      el.defineProperty('is_file_type_restricted', false);
      el.defineProperty('restricted_file_types', []);
      el.defineProperty('is_multiple_locked', el.inFormTemplate);
      el.defineProperty('individual_max_file_size_mb_locked', el.inFormTemplate);
      el.defineProperty('total_max_file_size_mb_locked', el.inFormTemplate)
    }
    if (el.can(Capability.columnable)) {
      el.defineProperty('column_count', 1);
      el.defineProperty('column_count_locked', el.inFormTemplate);
    }
    if (el.can(Capability.defaultOption)) {
      el.defineProperty('default_option_type', DefaultOptionType.None);
      el.defineProperty('default_option_id', null);
      el.defineProperty('default_option', 'Select one...');
      el.defineProperty('default_option_locked', el.inFormTemplate);
      el.defineProperty('default_option_id_locked', el.inFormTemplate);
    }
    if (el.can(Capability.defaultable)) {
      el.defineProperty('default_value', null);
      el.defineProperty('default_value_locked', el.inFormTemplate);
    }
    if (el.can(Capability.maskable)) {
      el.defineProperty('is_masked', false);
      el.defineProperty('masked_before_ssn', null);
      el.defineProperty('is_masked_locked', el.inFormTemplate);
      el.defineProperty('security_maskable_partial_display_character_count', 0)
    }
    if (el.can(Capability.checkByDefault)) {
      el.defineProperty('check_by_default', false);
      el.defineProperty('check_by_default_locked', el.inFormTemplate);
    }
    if (el.can(Capability.readonlyable)) {
      el.defineProperty('is_readonly', false);
      el.defineProperty('is_readonly_locked', el.inFormTemplate);
    }
    if (el.can(Capability.showHideable)) {
      el.defineProperty('default_show', true);
      el.defineProperty('default_show_locked', el.inFormTemplate);
      el.defineProperty('clear_hidden_on_submit', true);
    }
    if (el.can(Capability.optionRangeRequirable)) {
      el.defineProperty('option_range_type', OptionRangeType.AtLeast);
      el.defineProperty('checkbox_range_min', 1);
      el.defineProperty('checkbox_range_max', null);
    }
    if (el.can(Capability.lengthable)) {
      el.defineProperty('character_count_locked', el.inFormTemplate);
    }
    if (el.can(Capability.thirdPartyCompleter)) {
      el.defineProperty('request_phone_locked', el.inFormTemplate);
    }
    if (el.can(Capability.verticalAlign)) {
      el.defineProperty('vertical_alignment', VerticalAlignment.Top);
    }
    if (el.can(Capability.resizable)) {
      el.defineProperty('frame_shape', FrameShape.Square);
      el.defineProperty('frame_width', null);
      el.defineProperty('frame_height', null);

      el.defineProperty('allow_image_min_max', false);
      el.defineProperty('image_width_min', null);
      el.defineProperty('image_width_max', null);
      el.defineProperty('image_height_min', null);
      el.defineProperty('image_height_max', null);
    }
    if (el.can(Capability.dataReferencable)) {
      el.defineProperty('reference_data_ids', []);
      el.defineProperty('licenses', []);
      el.defineProperty('object_model_id', null);
      el.defineProperty('object_model_instance_selection_limit', null);
      el.defineProperty('object_model_search_property_ids', []);
      el.defineProperty('object_model_search_match_type', SearchMatchType.CloseVariant);
      el.defineProperty('object_model_search_result_label_property_ids', []);
      el.defineProperty('list_view_id', null);
      el.defineProperty('lookup_type', LookupFieldType.objectModels);
    }
    if (el.can(Capability.profileConfig)) {
      el.defineProperty('profile_config_field_id', "");
    }

    if (el.can(Capability.validationRule)) {
      el.defineProperty('validation_reference_type', 0);
      el.defineProperty('validation_reference_object_model_id', '');
      el.defineProperty('if_record_exists', true);
    }

    if (el.can(Capability.wysiwygFormattable)) {
      el.defineProperty('is_wysiwyg_formattable', false)
      el.defineProperty('wysiwyg_formattable_text', "")
      el.defineProperty('is_wysiwyg_formattable_locked', el.inFormTemplate);
    }
  }

  /**
   * FormElementCapabilityManager#formElementCan uses current state/configs (e.g. is_repeatable)
   * to determine if element is capable
   * FormElementCapabilityManager#formElementCanBe determines if there is ever a possibility
   * the element could ever be capable
   *
   * This solves issue of grids not being Capability.referenceable on initial creation
   * since element.is_repeatable always starts as false but must be true to actually set the config
   */
  static formElementCanBe(type: FormElementType, duty: Capability) {
    let can: boolean
    switch (duty) {
      case Capability.referenceable:
        can = FormElementCapabilityManager.REFERENCEABLE_CONTROLS.includes(type);
        break;
      default:
        can = FormElementCapabilityManager.formElementCan(type, duty)
        break;
    }
    FormElementCapabilityManager.log(`Type ${FormElementType[type]} ${can ? 'can be' : 'can\'t be'} ${Capability[duty]}`);
    return can;
  }

  private static log(message: string) {
    if (this.debug) {
      console.log(`DEBUG: FormElementCan: ${message}`);
    }
  }
}